import React from 'react';
import {View} from '@react-pdf/renderer';
import {IntlShape} from 'react-intl';
import PlateToPdf from '../PlateToPdf';
import QuotePage from './QuotePage';
import SectionLabel from './SectionLabel';
import {buildStyles} from './quotePdfStyles';
import type {QuoteDocumentData, QuoteTemplate} from '../resolver/types';

type QuoteNarrativePageProps = {
	data: QuoteDocumentData;
	template: QuoteTemplate;
	intl: IntlShape;
};

/**
 * Introduction and Scope of work — two independently toggleable narrative sections. The page
 * itself is only rendered when at least one of them is on.
 */
const QuoteNarrativePage = ({data, template, intl}: QuoteNarrativePageProps): JSX.Element => {
	const styles = buildStyles(template.font);
	return (
		<QuotePage data={data} template={template} intl={intl}>
			{template.showIntroduction && (
				<View style={styles.section}>
					<SectionLabel font={template.font} brandColor={template.brandColor}>
						{intl.formatMessage({id: 'quote_designer.section.introduction'})}
					</SectionLabel>
					<PlateToPdf value={template.introduction} baseStyle={styles.paragraph} />
				</View>
			)}
			{template.showScopeOfWork && (
				<View style={styles.section}>
					<SectionLabel font={template.font} brandColor={template.brandColor}>
						{intl.formatMessage({id: 'quote_designer.section.scope'})}
					</SectionLabel>
					<PlateToPdf value={template.scopeOfWork} baseStyle={styles.paragraph} />
				</View>
			)}
		</QuotePage>
	);
};

export default QuoteNarrativePage;
